/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery'
import 'bootstrap/js/dist/dropdown'

const showClass = 'show'

function openDropdown($container) {
  const $toggle = $container.find('.dropdown-toggle')
  const $dropdownMenu = $container.find('.dropdown-menu')
  $container.addClass(showClass)
  $toggle.attr('aria-expanded', 'true')
  $dropdownMenu.addClass(showClass)
}

function closeDropdown($container) {
  const $toggle = $container.find('.dropdown-toggle')
  const $dropdownMenu = $container.find('.dropdown-menu')
  $container.removeClass(showClass)
  $toggle.attr('aria-expanded', 'false')
  $dropdownMenu.removeClass(showClass)
}

const $doc = $(document)

$doc.on('click', '.nav .dropdown-toggle', (ev) => {
  const $target = $(ev.currentTarget)
  if ($target.prop('tagName') === 'A' && $target.closest('.nav').length) {
    document.location.href = $target.attr('href')
  }
})

$doc.on('keydown', '.nav .dropdown-toggle', (ev) => {
  if (ev.key === 'Enter' || ev.key === ' ') {
    ev.preventDefault()
    return false
  }
  if (ev.key === 'ArrowDown') {
    const $dropdown = $(ev.currentTarget).parent().find('.dropdown')
    if ($dropdown.length) {
      openDropdown($dropdown)
    }
  }
  return true
})

$doc.on('mouseenter', '.dropdown', (ev) => {
  const $container = $(ev.currentTarget)
  $container.data('has-mouse', true)
  openDropdown($container)
})

$doc.on('mouseleave', '.dropdown', (ev) => {
  const $container = $(ev.currentTarget)
  $container.data('has-mouse', false)

  let closeTimer = null
  const resetTimer = () => {
    clearTimeout(closeTimer)
    closeTimer = setTimeout(() => {
      if ($container.data('has-mouse') === true) {
        clearTimeout(closeTimer)
        return
      }
      closeDropdown($container)
    }, 500)
  }

  resetTimer()
})

